
import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const CTASection: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 md:py-24 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          className="bg-gradient-to-r from-[#0c1420] to-[#151f2e] rounded-2xl overflow-hidden border border-[#223342] p-8 md:p-12 relative" 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#00B6F0]/10 to-[#8B5CF6]/10 blur-3xl"></div>
          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white text-center mb-6">
              Tá na hora de <span className="text-[#00B6F0]">detonar</span> no game!
            </h2>
            <p className="text-gray-300 text-lg text-center mb-8 max-w-2xl mx-auto">
              Entre na Arena hoje e conecte-se com mentores pro players que vão 
              te ajudar a arrasar nos seus games favoritos!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                onClick={() => navigate("/cadastro")} 
                size="lg" 
                className="bg-gradient-to-r from-[#00B6F0] to-[#0077B6] text-black font-bold hover:opacity-90 hover:scale-105 transition-all px-8"
              >
                Criar Conta
              </Button>
              <Button 
                onClick={() => navigate("/mentores")} 
                size="lg" 
                variant="outline" 
                className="border-[#00B6F0] text-[#00B6F0] hover:bg-[#00B6F0]/10 px-8"
              >
                Explorar Mentores
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
